/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Select, MenuItem } from '@material-ui/core';
import { setNewdAddress, setUserData } from '../../redux/user';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import './style.scss';

const validationSchema = Yup.object({
  street: Yup.string().trim().required('Campo obligatorio'),
  streetNumber: Yup.string().trim().required('Campo obligatorio'),
  zipCode: Yup.string()
    .trim()
    .matches(/^[a-zA-Z0-9]+$/)
    .required('Campo obligatorio'),
  department: Yup.string()
    .trim()
    .matches(/^[a-zA-Z0-9ñÑ]+$/),
  state: Yup.string().trim().required('Campo obligatorio'),
  locality: Yup.string().trim().required('Campo obligatorio'),
});

const builInitialValues = (currentAddress, addNewAddress) => {
  let addressInfo = {
    street: '',
    streetNumber: '',
    floor: '',
    department: '',
    zipCode: '',
    state: '',
    locality: '',
  };
  if (!addNewAddress && currentAddress) {
    // This is due the address values got from the service are not normalized
    if (currentAddress.floor) {
      const sanitizeFloor = currentAddress.floor.trim();
      addressInfo.floor = sanitizeFloor.substr(0, 2);
      addressInfo.department = sanitizeFloor.substr(2, 3);
    }
    addressInfo.street = currentAddress.street && currentAddress.street.trim();
    addressInfo.streetNumber = currentAddress.streetNumber;
  }
  return addressInfo;
};

export default function AddressForm(props) {
  const { provinces, nextWasRequired } = props;
  const dispatch = useDispatch();

  const { currentAddress, addNewAddress } = useSelector(({ user }) => ({
    currentAddress: user.currentAddress,
    addNewAddress: user.addNewAddress,
  }));

  const initialValues = builInitialValues(currentAddress, addNewAddress);

  const { values, errors, touched, setFieldValue, handleBlur } = useFormik({
    initialValues,
    validationSchema,
  });

  const { insuranceSelected } = useSelector(({ insurances }) => ({
    insuranceSelected: insurances.selected,
  }));

  const { insuranceName } = insuranceSelected || {};

  const { userCarInsurance } = useSelector(({ carInsurance }) => ({
    userCarInsurance: carInsurance.userCarInsurance,
    carPostCode: carInsurance.userCarInsurance.carPostCode,
    carCity: carInsurance.userCarInsurance.carCity,
  }));

  useEffect(() => {
    if (!addNewAddress) {
      dispatch(setNewdAddress({ ...initialValues }));
    }
    if (insuranceName === 'AUTOMOTOR') {
      values.locality = userCarInsurance.carCity;
      values.zipCode = userCarInsurance.carPostCode;
      dispatch(
        setUserData({
          currentAddress: {
            locality: userCarInsurance.carCity,
            zipCode: userCarInsurance.carPostCode,
          },
        })
      );
    }
    if (insuranceName === 'INTEGRAL DE COMERCIO' || addNewAddress) {
      values.street = '';
      values.streetNumber = '';
      values.floor = '';
      values.department = '';
      values.state = '';
      values.zipCode = '';
      values.locality = '';
      dispatch(
        setUserData({
          currentAddress: { floor: '' },
        })
      );
    }
  }, []);

  useEffect(() => {
    const validationErrors = Object.keys(errors).length > 0;
    const valuesRequired =
      values.street &&
      values.streetNumber &&
      values.state &&
      values.zipCode &&
      values.locality &&
      true;

    if (!validationErrors && valuesRequired) {
      dispatch(setNewdAddress({ isValid: true }));
    }
    if (currentAddress && currentAddress.isValid && validationErrors) {
      dispatch(setNewdAddress({ isValid: false }));
    }
  }, [values, errors]);

  const hasError = (input, inputValue) =>
    (touched[input] && errors[input]) || (nextWasRequired && inputValue === '');

  const error = 'campo obligatorio';

  function sanitizeInputs(event) {
    const isAlphanumeric =
      event.charCode === 0 ||
      /^[a-zA-Z0-9ñÑ]*$/.test(String.fromCharCode(event.charCode));
    if (!isAlphanumeric) event.preventDefault();
    return;
  }

  function handleChange(e) {
    const key = e.target.name;
    let value = e.target.value;

    if (key === 'state') {
      const province = provinces.filter(
        (p) => p.provinceCodeId === e.target.value
      );
      value = { name: province[0].shortDesc, value: e.target.value };
    }

    setFieldValue(key, value);
    dispatch(setNewdAddress({ [key]: value }));
  }

  return (
    <div className='Form-Container-AddressForm'>
      <div className='Form-Top-AddressForm'>
        <span className='Form-Header-AddressForm'>Datos del domicilio</span>
        <div className='Form-Icon-AddressForm'>
          <i className='tiny material-icons'>create</i>
        </div>
      </div>
      <form className='col s12'>
        <div className='row'>
          <div className='input-field col s12 l4'>
            <input
              autoComplete='off'
              value={values.street}
              id='street'
              name='street'
              type='text'
              className={`validate inputField ${
                hasError('street', values.street) ? 'error' : ''
              }`}
              onChange={handleChange}
              onBlur={handleBlur}
              maxLength='60'
            />
            <span htmlFor='street'>Calle</span>
            <p className='error-text'>
              {hasError('street', values.street) && error}
            </p>
          </div>
          <div className='input-field col s6 l2'>
            <input
              autoComplete='off'
              value={values.streetNumber}
              id='streetNumber'
              name='streetNumber'
              type='text'
              className={`validate inputField ${
                hasError('streetNumber', values.streetNumber) ? 'error' : ''
              }`}
              onChange={handleChange}
              onBlur={handleBlur}
              onKeyPress={sanitizeInputs}
              maxLength='5'
            />
            <span htmlFor='streetNumber'>Número</span>
            <p className='error-text'>
              {hasError('streetNumber', values.streetNumber) && error}
            </p>
          </div>
          <div className='input-field col s6 l2'>
            <input
              autoComplete='off'
              value={values.floor}
              name='floor'
              id='floor'
              className='validate inputField'
              onChange={handleChange}
              onBlur={handleBlur}
              onKeyPress={sanitizeInputs}
              type='text'
              pattern='\d*'
              maxLength='2'
            />
            <span htmlFor='floor'>Piso</span>
          </div>
          <div className='input-field col s6 l2'>
            <input
              autoComplete='off'
              value={values.department}
              name='department'
              id='department'
              type='text'
              className='validate inputField'
              onChange={handleChange}
              onBlur={handleBlur}
              onKeyPress={sanitizeInputs}
              maxLength='3'
            />
            <span htmlFor='department'>Departamento</span>
          </div>
          <div className='input-field col s6 l2'>
            <input
              value={values.zipCode}
              name='zipCode'
              id='zipCode'
              type='number'
              readOnly={insuranceName === 'AUTOMOTOR' ? true : false}
              onBlur={handleBlur}
              onChange={handleChange}
              onKeyPress={sanitizeInputs}
              className={`validate inputField ${
                hasError('zipCode', values.zipCode) ? 'error' : ''
              }`}
              min='0'
            />
            <span htmlFor='zipCode'>CP</span>
            <p className='error-text'>
              {hasError('zipCode', values.zipCode) && error}
            </p>
          </div>
          <div className='input-field col s12 l5'>
            <Select
              id='state'
              name='state'
              value={values.state.value || ''}
              className={`validate inputField selectField ${
                hasError('state', values.state) ? 'error' : ''
              }`}
              classes={{ root: 'menuSelect', icon: 'caret' }}
              inputProps={{
                classes: {
                  icon: 'caret',
                },
              }}
              onChange={handleChange}
              onBlur={handleBlur}
            >
              {provinces.length > 0 &&
                provinces.map((item, key) => {
                  return (
                    <MenuItem key={key} value={item.provinceCodeId}>
                      {item.shortDesc}
                    </MenuItem>
                  );
                })}
            </Select>
            <span>Provincia</span>
            <p className='error-text error-select'>
              {hasError('state', values.state) && error}
            </p>
          </div>
          <div className='input-field col s12 l5'>
            <input
              value={values.locality}
              id='locality'
              name='locality'
              type='text'
              readOnly={insuranceName === 'AUTOMOTOR' ? true : false}
              className={`validate inputField locality-input-field ${
                hasError('locality', values.locality) ? 'error' : ''
              }`}
              onChange={handleChange}
              onBlur={handleBlur}
              maxLength='20'
            />
            <label htmlFor='locality'>Localidad</label>
            <p className='error-text error-select'>
              {hasError('locality', values.locality) && error}
            </p>
          </div>
        </div>
      </form>
    </div>
  );
}
